/**
 * Range slider
 * @requires https://refreshless.com/nouislider/
 */

export default (() => {
  const rangeSliderWidgets = document.querySelectorAll('[data-range-slider]')

  if (rangeSliderWidgets.length === 0) return

  // Check the dir attribute on html tag and set the default to "ltr" if it's not set or invalid
  const htmlElement = document.documentElement
  const direction =
    htmlElement.getAttribute('dir') === 'ltr' ||
    htmlElement.getAttribute('dir') === 'rtl'
      ? htmlElement.getAttribute('dir')
      : 'ltr'

  rangeSliderWidgets.forEach((rangeSliderWidget) => {
    const rangeSlider = rangeSliderWidget.querySelector('.range-slider-ui')
    const valueMinInput = rangeSliderWidget.querySelector(
      '[data-range-slider-min]'
    )
    const valueMaxInput = rangeSliderWidget.querySelector(
      '[data-range-slider-max]'
    )

    let dataOptions
    if (rangeSliderWidget.dataset.rangeSlider !== undefined)
      dataOptions = JSON.parse(rangeSliderWidget.dataset.rangeSlider)

    const options = {
      startMin: Number(dataOptions.startMin.toFixed(2)),
      startMax: Number(dataOptions.startMax.toFixed(2)),
      min: Number(dataOptions.min.toFixed(2)),
      max: Number(dataOptions.max.toFixed(2)),
      step: Number(dataOptions.step.toFixed(2)),
      pips: dataOptions.pips,
      tooltipPrefix: dataOptions.tooltipPrefix || '',
      tooltipSuffix: dataOptions.tooltipSuffix || '',
    }

    const start = options.startMax
      ? [options.startMin, options.startMax]
      : [options.startMin]
    const connect = options.startMax ? true : 'lower'

    /* eslint-disable no-undef */
    noUiSlider.create(rangeSlider, {
      direction: direction,
      start: start,
      connect: connect,
      step: options.step,
      pips: options.pips ? { mode: 'count', values: 5 } : false,
      tooltips: true,
      range: {
        min: options.min,
        max: options.max,
      },
      format: {
        to: function (value) {
          return (
            options.tooltipPrefix + value.toFixed(2) + options.tooltipSuffix
          )
        },
        from: function (value) {
          return Number(value)
        },
      },
    })

    rangeSlider.noUiSlider.on('update', (values, handle) => {
      let value = values[handle]
      value = value.replace(/\D/g, '')
      let value_num = value / 100
      if (handle) {
        if (valueMaxInput) {
          valueMaxInput.value = value_num
        }
      } else {
        if (valueMinInput) {
          valueMinInput.value = value_num
        }
      }
    })

    if (valueMinInput) {
      valueMinInput.addEventListener('change', function () {
        rangeSlider.noUiSlider.set([this.value, null])
      })
    }

    if (valueMaxInput) {
      valueMaxInput.addEventListener('change', function () {
        rangeSlider.noUiSlider.set([null, this.value])
      })
    }
  })
  /* eslint-enable no-undef */
})()
